<!doctype html>
<html lang="en">

<head>
    <meta charset="utf-8">
    <meta content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0' name='viewport' />
    <meta name="viewport" content="width=device-width" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">
    <title>Hotel Voucher</title>
    <style>@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,400,400i,600,600i,700,700i);@import url(https://fonts.googleapis.com/css?family=Rubik:300,400,500);*,body{margin:0;padding:0}*{box-sizing:border-box}html{scroll-behavior:smooth}body{color:#363636;font-size:14px;font-weight:300;line-height:1.6;background-color:#f5f5f5;font-family:Rubik,sans-serif}.container{max-width:1100px;padding:20px;margin:25px auto;background-color:#fff}.voucher-outer{border:1px solid #0b477f;padding:10px}.hotel-details h3,.top-head{border-bottom:3px solid #0b477f}.top-head{width:100%;display:inline-block;padding-bottom:14px}.left-box{width:70%;float:left}.right-box{width:30%;float:left}.right-box img{float:right;margin-right:20px;margin-top:12px}.left-box h3{font-size:27px;font-weight:500}.left-box span{display:block}.usr-nme{font-size:15px;font-weight:400;width:100%;position:relative;padding:5px}.usr-nme a{float:right}.book-con-box{background-color:#0b477f1a;padding:15px 0 15px 15px;color:#000;font-size:19px;font-weight:400;margin-top:10px;margin-bottom:10px}.book-con-box i{margin-right:5px;font-size:26px;position:relative;top:3px}.hotel-details h3{font-size:18px;font-weight:500;margin-top:12px;color:#0b477f;padding-bottom:5px}.client-info,.hotel-name{margin-top:10px}.hotel-name{font-size:17px;font-weight:400}.client-info p span{font-weight:500}.table-box{margin-top:20px}.table-box .table{width:100%;max-width:100%;margin-bottom:1rem;background-color:transparent;border-collapse:collapse}.table-box .table thead th{vertical-align:bottom;border-bottom:2px solid #0b477f;padding:.75rem;border-top:2px solid #0b477f;text-align:center}.table-box .table td{vertical-align:top;padding:.75rem}.br-btm td{border-bottom:2px solid #dee2e6;text-align:center}.contact h3,.inclu-box h3{font-size:18px;color:#0b477f;border-bottom:3px solid #0b477f;font-weight:500}.tx-r td{text-align:right}.fl-col{background-color:#f5f5f5;font-weight:500}.inclu-box h3{margin-top:12px;padding-bottom:5px;margin-bottom:10px}.inclu-box ul{margin:0;padding:0}.inclu-box ul li{list-style:none;position:relative;left:20px;margin-right:30px;text-align:justify}.inclu-box ul li::before{content:'\f101';font-family:FontAwesome;position:absolute;left:-17px}.contact{width:100%;display:inline-block;margin-bottom:20px}.contact-left,.contact-right{width:50%;float:left}.contact h3{margin-top:12px;padding-bottom:5px;margin-bottom:10px}.contact-left h4{font-size:17px;font-weight:500}.contact-right span{font-weight:500}a{color: #0b477f;}</style>
</head>

<body>
    <div class="container">
        <div class="voucher-outer">
            <div class="top-head">
                <div class="left-box">
                    <h3>Hotel Confirmation Voucher</h3>
                    <span>Sourcemytrip Booking ID - NH7003765779695</span>
                    <span>Booking Date - Fri, 20 May 20 11:59 AM</span>
                </div>
                <div class="right-box">
                    <img src="assets/images/logo-main.png">
                </div>
            </div>
            <div class="user-info">
                <p class="usr-nme">Dear Rajiv Shah,
                    <a href=""><i class="fa fa-print" aria-hidden="true"></i>
Print Booking Confirmation</a> </p>
                <div class="book-con-box">
                    <i class="fa fa-check-circle-o" aria-hidden="true"></i> Your Booking is confirmed
                </div>
                <p>Thank you for using sourcemytrip.com to book your hotel accommodation.</p>
                <p>Hotel Voucher No: 25328198
                </p>
                <p>
                    Kindly note, your booking is CONFIRMED and you are not required to contact the hotel or Sourcemytrip to reconfirm the same.
                </p>
            </div>
            <div class="hotel-details">
                <h3>Hotel Details</h3>
                <div class="hotel-name">
                    Cama Rajputana Club Resort, MOUNT ABU
                </div>
                <p>Adhar Devi Road mount abu Adhar Devi Road Mount Abu , MOUNT ABU, I</p>
                <p>Contact : 02974238205,238206, 946184348</p>
                <p>Fax : 91-2974-238412</p>
                <p>E-mail : reservations@abchotel.com
                </p>
                <div class="client-info">
                    <p><span>Primary Guest</span> : Rajiv Shah</p>
                    <p><span>Room Category</span> : Deluxe</p>
                    <p><span>Meal Plan</span> : Breakfast</p>
                </div>
            </div>
            <div class="table-box">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Room</th>
                            <th>Check In</th>
                            <th>Check Out</th>
                            <th>#Nights</th>
                            <th>Travelers</th>
                            <th>Daily Rate</th>
                            <th>Extra Charges</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="br-btm">
                            <td>Superior</td>
                            <td>Thu, Dec14, 2017</td>
                            <td>Fri, Sun 17, 2017</td>
                            <td>3</td>
                            <td>2 Adults</td>
                            <td>5782.0</td>
                            <td>(No Extra Charges)</td>
                            <td>17346.0</td>
                        </tr>
                        <tr class="tx-r">
                            <td colspan="7"><b>Sub Total</b></td>
                            <td>17346.0</td>
                        </tr>
                        <tr class="tx-r">
                            <td colspan="7"><b>Taxes & Service Fee</b></td>
                            <td>17346.0</td>
                        </tr>
                        <tr class="tx-r fl-col">
                            <td colspan="7">Grand Total</td>
                            <td>17346.0</td>
                        </tr>


                    </tbody>
                </table>
            </div>
            <div class="inclu-box">
                <h3>Inclusions</h3>
                <ul>
                    <li>FREE Breakfast and Dinner</li>
                    <li>Accommodation</li>
                </ul>
            </div>
            <div class="inclu-box">
                <h3>Hotel Cancellation Policy</h3>
                <ul>
                    <li>From booking date to 2017-1 1-11 14:00:00,0% penalty will be charged.From 2017-1 1-11 14:00:00 to 2017-1 1-14 14:00:00,100% penalty will be charged.I n case of no show : no refund.Booking cannot be cancelled/modified on or after the check in date and time mentioned in the Hotel Confirmation Voucher .
                    </li>
                    <li>You can cancel your booking by logging on the Customer Support section of our website</li>
                </ul>
            </div>
            <div class="inclu-box">
                <h3>General Hotel Policy</h3>
                <ul>
                    <li>Early check-in or late check-out is subject to availability and may be chargeable by the hotel. The standard check-in time is 2PM local time and the standard check-out time is 12PM local time. After booking you will be sent an email confirmation with hotel phone number . You can contact the hotel directly for early check-in or late check-out.
                    </li>
                    <li>The amount paid for the room does not include charges for optional services and facilities (such as room service, mini bar, snacks or telephone calls). These will be charged at the time of check-o</li>
                    <li>The hotel reserves the right of admission. Accommodation can be denied to guests posing as a 'couple' if suitable proof of identification is not presented at check-in. Sourcemytrip will not be responsible for any check-in denied by the hotel due to the aforesaid reason.</li>
                    <li>Hotel reserves the right of admission for local residents. Accommodation can be denied to guests residing in the same city. Sourcemytrip will not be responsible for any check-in denied by the hotel due to the aforesaid reason.</li>
                </ul>
            </div>
            <div class="contact">
                <h3>Sourcemytrip Contact Info</h3>
                <div class="contact-left">
                    <h4>Sourcemytrip</h4>
                    <p>126, 1 Floor, Kirti Shikhar Tower,<br> Janakpuri, New Delhi-58<br>India</p>
                </div>
                <div class="contact-right">
                    <p><span>Email</span> : chandra@sourcemytrip.com </p>
                    <p><span>Phone</span> : 9873674120, 011-41040505 </p>
                    <p><span>Website</span> : www.sourcemytip.com</p>
                </div>
            </div>
        </div>
    </div>


</body>

</html>
